/* eslint-disable */
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { connect } from "react-redux";
import { breakDownCollectionSummaryAction } from "../../../../redux/action-creators/dayWiseBreakDownActionCreator";
import { selectDateFilter } from "../../../../redux/actions/dateFilterAction";
import { PageWrapper } from "../../../../shared/layout";
import { BarLoader } from "../../../../shared/widgets";
import CurrentDue from "./CurrentDue";
import PreviousSettlements from "./PreviousSettlements";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  grid: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  tab: {
    marginLeft: theme.spacing(4),
  },
  title: {
    flexGrow: 1,
  },
}));

const tabs = [
  {
    key: "currentDue",
    display: "Net Due",
  },
  {
    key: "previousSettlements",
    display: "Previous Settlements",
  },
];

function OperatorSettlement(props) {
  const isFirstRender = React.useRef(0);
  const classes = useStyles();
  let operatorName = (props && props.location && props.location.state && props.location.state.operatorName) || "12344";
  operatorName = operatorName.toString().replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
  const operatorId = (props.location && props.location.state && props.location.state.operatorId && props.location.state.operatorId.toString()) || "154";
  const cityId = (props.location && props.location.state && props.location.state.cityId && props.location.state.cityId.toString()) || "";
  const operatorFilterArray = [];
  const cityFilterArray = [];
  cityFilterArray.push(cityId);
  operatorFilterArray.push(operatorId);

  const [value, setValue] = React.useState(props.location.state?.isFromSettledDues ? "previousSettlements" : "currentDue");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  React.useEffect(() => {
    if (isFirstRender.current !== 2) {
      isFirstRender.current += 1;
    } else {
      props && props.history && props.history.push("/settlement");
    }
  }, [props.operatorFilter, props.cityFilter]);

  return (
    <div className={classes.root}>
      <PageWrapper>
        <PageWrapper.Header heading={operatorName} showBackArrow hideLower hideDivider hideS/>
        <PageWrapper.Body style={{ marginTop: 80 }}>
          {value == "currentDue" ? (
            <CurrentDue operatorId={operatorId} cityId={cityId} />
          ) : (
            <div>
              <BarLoader scope="header" />
              <PreviousSettlements
                operatorId={operatorFilterArray}
                cityId={cityFilterArray}
                state={
                  (props && props.location && props.location.state) || null
                }
                operatorName={operatorName}
              />
            </div>
          )}
        </PageWrapper.Body>
      </PageWrapper>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    settlementSummary: (state && state.Settlement && state.Settlement.settlementSummary) || {},
    currentDueLoader: (state && state.loadingBar && state.loadingBar.currentDueLoader),
    cityFilter: state.Cities.selectedCity,
    selectedDateFilter: state.DateFilter.selectedDateFilter,
    operatorFilter: state.Operators.selectedOperator,
  };
}

const mapDispatchToProps = (dispatch, state) => ({
  fetchBusDetailSummary: (busNumber) => {
    dispatch(breakDownCollectionSummaryAction(busNumber));
  },
  selectDateFilter: (value) => {
    dispatch(selectDateFilter(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(OperatorSettlement);
